// Arumi: remembers the shopper's last searches (in this browser only) and shows them as chips
(function () {
  if (window.ArumiRecentSearches) return;

  var KEY = 'arumi:recent-searches';
  var MAX = 6;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (t) { return typeof t === 'string' && t; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function remember(term) {
    term = (term || '').trim().replace(/\s+/g, ' ').slice(0, 60);
    if (term.length < 2) return;
    var lower = term.toLowerCase();
    var list = read().filter(function (t) { return t.toLowerCase() !== lower; });
    list.unshift(term);
    write(list.slice(0, MAX));
  }

  function searchUrl(term) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
  }

  function render() {
    var list = read();
    document.querySelectorAll('.arumi-search__recent').forEach(function (box) {
      var ul = box.querySelector('.arumi-search__chips');
      ul.textContent = '';
      list.forEach(function (term) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'arumi-search__chip arumi-search__chip--recent';
        a.href = searchUrl(term);
        a.setAttribute('data-arumi-term', term);
        a.innerHTML =
          '<svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>';
        a.appendChild(document.createTextNode(term));
        li.appendChild(a);
        ul.appendChild(li);
      });
      box.hidden = list.length === 0;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form.arumi-search');
    if (form) remember(form.querySelector('input[type="search"]').value);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var clear = event.target.closest('.arumi-search__clear-recent');
    if (clear) {
      event.preventDefault();
      write([]);
      render();
      return;
    }
    var chip = event.target.closest('[data-arumi-term]');
    if (chip) {
      remember(chip.getAttribute('data-arumi-term'));
      return;
    }
    // Opening a product from the results also counts as having searched for the typed text
    var result = event.target.closest('.arumi-search .search__results a[href]');
    if (result) {
      var form = result.closest('form.arumi-search');
      remember(form.querySelector('input[type="search"]').value);
    }
  });

  document.addEventListener('focusin', function (event) {
    if (event.target.matches && event.target.matches('.arumi-search input[type="search"]')) render();
  });

  window.ArumiRecentSearches = { render: render };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
